import { useContext } from 'react';
import { WindowSizeContext } from '../../../../../common/context/WindowSizeContext';
import ConditionalSelectComponent from '../../../../../common/components/ConditionalSelectComponent';
import { useSelectorState, useSelectorValue } from '../../../common/providers/selectorProvider';
import { getSelectedOption, useCategoryName } from '../../hooks';

export default function CategorySelector({ tableName, disabled }) {
    const windowSize = useContext(WindowSizeContext);
    const companySelected = useSelectorValue('initial_company_id');
    const regionSelected = useSelectorValue('initial_region');
    const storeSelected = useSelectorValue('initial_store');
    const { data, isLoading } = useCategoryName(tableName, companySelected, regionSelected, storeSelected);
    const [initialSelectedCategory, setInitialSelectedCategory] = useSelectorState('initial_category')

    const loadingState = Boolean(isLoading || data === undefined);

    const optionListCategory = (data || [])
        .map((categoryName) => {
            return {
                value: categoryName,
                label: categoryName
            }
        })
        .flat()
        .filter((option) => option?.value !== "" && option?.label !== "")
        .sort((a, b) => a?.label?.localeCompare(b?.label));

    function handleSelectCategoryValue(value) {
        setInitialSelectedCategory(value);
        return value;
    }

    return (
        <>
            <ConditionalSelectComponent
                isLoading={isLoading}
                id="category"
                labelId="category-label"
                options={optionListCategory}
                label="Category"
                disabled={isLoading}
                value={getSelectedOption(initialSelectedCategory, optionListCategory) || null}
                onSelectChange={(event, newValue) => {
                    if (windowSize.isOnMobile) {
                        handleSelectCategoryValue(event.target.value);
                    } else {
                        // newValue is the selected option object (or null)
                        handleSelectCategoryValue(newValue?.value || null);
                    }
                }}
                endAdornment={false}
                disableClearable={true}
            />
        </>
    );
}
